import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
    <g fill="none" fillRule="evenodd" stroke="#979797" strokeWidth="1.5">
      <path d="M14.142 0v28.284M0 14.142h28.284" />
    </g>
  </svg>
);
